import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Category';
import create from './create';
import edit from './edit';
import list from './list';

const messageSubjects: ResourceProps = {
  name: 'message-subjects',
  icon,
  options: { label: 'Assuntos' },
  create,
  edit,
  list
};

export default messageSubjects;
